<template>
  <a-modal
    :open="computedShowModal"
    width="600px"
    title="클라라 발송 대상 조회"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{ backdropFilter: 'blur(2px)' }"
    :keyboard="false"
    :destroyOnClose="true"
    @cancel="closeModal"
    centered
>
    <div class="clara-modal-container">
        <a-table
            :dataSource="deliveryDatesTableData"
            :columns="columns"
            :pagination="deliveryTablePagination"
            @change="handleDeliveryTableChange"
            size="middle"
        >
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'status'">
                                    <span class="status-badge" :class="record.status">
                                        {{ record.status === 'sent' ? '발송완료' : '발송예정' }}
                                    </span>
                </template>
                <template v-if="column.key === 'resend'">
                <a-tooltip title="알림톡 재발송" placement="top">
                    <button
                        class="kakao-icon"
                        style="background-color: #ffe414; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; border: none; border-radius: 100%; padding: 0;"
                        @click="sendTheCurrentNftClaraAlimtalk(record.index, record.date)"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                        <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#2F3337"/>
                    </svg>
                    </button>
                </a-tooltip>
                </template>
            </template>
        </a-table>
    </div>
</a-modal>
</template>
<script>
import {
  MedicalDept,
  WarrantyStatusEnum,
  WarrantyImgUrlEnum,
  YnEnum,
  OphCompanies,
} from '@/enums/common.enums';
import {
  CertifiedCompanies,
  SurfaceCompanies,
} from '@/enums/dent.enums';
import {
  phoneNumberFormatter,
  convertDate,
  convertDateTime,
  oneBtnDialog,
  twoBtnDialog,
  twoBtnHtmlDialog,
  getValueByTraitType,
  convertDeptText,
  logging,
} from '@/utils/utils';
import Pagination from '@/views/components/Pagination.vue';

import dayjs from 'dayjs';
require('dayjs/locale/ko'); // 한국어 요일을 표시하고 싶다면 한국어 로케일을 불러옵니다.
dayjs.locale('ko'); // 로케일을 설정합니다.
import {
  PlusOutlined,
  CloseOutlined,
  MoreOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue';
export default {
  components: {
    PlusOutlined,
    CloseOutlined,
    MoreOutlined,
    DeleteOutlined,
    Pagination,
  },
  emits: ['closeModal'],
  data() {
    return {
      window,
      WarrantyStatusEnum,
      dayjs,
      paginationData: {
        rowsPerPage: 10,
        currentPage: parseInt(this.$route.query.currentPage) || 1,
        totalPages: 0,
        total: 0,
      },
      customerInfo:{
        name:'',
        mobile:'',
        birth:'',
        gender:'',
        klipAddress:'',
      },

      medicalDept: [],
      MedicalDept,
      nftList: [],
      showNftDetailsData:null,
      deliveryDate : dayjs(),
      totalDeliveryCount:0,
      dateOfSurgeryFromToday: 0,
      daysLeftUntilSurgeryEndAtFromToday:0, //교정 종료 예정일
      showNftDetailsIndex: parseInt(this.$route.query.nftIndex) || 0,
      innerWidth: window.innerWidth,
      dentPrevTeethArray:[],
      previewAlimtalk:false,
      noResult: false,

      showDeliveryDatesModal: false,
      columns: [
        {
          title: '순서',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80,
          customRender: ({ text, record, index }) => {
            return <span>{index + 1}</span>;
          }
        },
        {
          title: '규칙',
          dataIndex: 'ruleNumber',
          key: 'ruleNumber',
          align: 'center',
          width: 100,
          customRender: ({ text, record }) => {
            return (
              <span style={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                width: '100%'
              }}>
                {record.index + 1}번째 규칙
              </span>
            );
          }
        },
        {
          title: '발송예정일',
          dataIndex: 'date',
          key: 'date',
          width: '30%',
          align: 'center'
        },
        {
          title: '상태',
          dataIndex: 'status',
          key: 'status',
          width: '20%',
          align: 'center',
          filters: [
            {text: '발송완료', value: 'sent'},
            {text: '발송예정', value: 'book'}
          ],
          onFilter: (value, record) => record.status === value,
          customRender: ({text, record}) => (
              <span class="status-badge" class={record.status}>
                            {record.status === 'sent' ? '발송완료' : '발송예정'}
                        </span>
          )
        },
        {
          title: '재발송',
          key: 'resend',
          width: '15%',
          align: 'center'
        },
        {
          title: '삭제',
          key: 'delete',
          width: '15%',
          align: 'center',
          customRender: ({ text, record }) => {
            const isSent = record.status === 'sent';
            
            return (
              <div style="display: flex; justify-content: center;">
                <a-tooltip title={isSent ? "이미 발송한 데이터는 삭제할 수 없습니다." : ""}>
                  <button
                    class="delete-icon"
                    style={{
                      backgroundColor: '#ff4d4f',
                      width: '28px',
                      height: '28px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: 'none',
                      borderRadius: '100%',
                      cursor: isSent ? 'not-allowed' : 'pointer',
                      opacity: isSent ? '0.5' : '1'
                    }}
                    onClick={() => !isSent && this.handleDeleteDelivery(record)}
                    disabled={isSent}
                  >
                    <DeleteOutlined style={{ color: '#fff', fontSize: '14px' }} />
                  </button>
                </a-tooltip>
              </div>
            );
          }
        }
      ],
      deliveryTablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        size: 'small',
        position: ['topRight'],
        showSizeChanger: true,
        showTotal: (total) => `총 ${total}개`,
        pageSizeOptions: ['10', '20', '50'],
        locale: {
          items_per_page: '개씩 보기',
          jump_to: '이동',
          jump_to_confirm: '확인',
          page: '페이지',
          prev_page: '이전 페이지',
          next_page: '다음 페이지',
          prev_5: '5페이지 뒤로',
          next_5: '5페이지 앞으로',
          prev_3: '3페이지 뒤로',
          next_3: '3페이지 앞으로'
        }
      },
      // 규칙데이터 미리보기를 위한 변수들
      deliveryRulePreviewData: [],
      activeTab: this.$route.query.activeTab,
    };
  },
  async mounted() {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    record: {
        type: Object || null,
        required: false,
        default: null,
    },
},
  computed: {
    computedShowModal() {
      return this.showModal;
    },
    computedQuery() {
      // 현재 라우트의 쿼리 파라미터를 복사
      const query = { ...this.$route.query };
          
      // customerName, customerMobile 등 불필요한 쿼리 제거
      delete query.customerName;
      delete query.customerMobile;
      delete query.currentPage;
      delete query.nftIndex;
      return query;
    },
    nextDeliveryDate() {
      let allArray = [...this.deliveryHistory].reverse();

      return allArray.filter(i => i.status == 'book' || i.status == 'new-data')[0] ?? null;
    },
    deliveryHistory() {
      let allArray = [];

      let plusDateCount = 0;
      this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle, index) => {
        let dateArray = [];
        for (let i = 1; i < currentSendCycle.afterDeliveryCount + 1; i++) {
          plusDateCount = plusDateCount + currentSendCycle.afterDeliveryDay;
          let status = 'error';
          if (currentSendCycle.currentDeliveryCount == null) {
            status = 'new-data'
          } else if (i <= currentSendCycle.currentDeliveryCount) {
            status = 'sent';
          } else if (i <= currentSendCycle.originalAfterDeliveryCount) {
            status = 'book';
          } else if (i > currentSendCycle.originalAfterDeliveryCount) {
            status = 'new-data';
          }
          dateArray.push({
            date: this.deliveryDate.add(plusDateCount, 'days'),
            status
          });
        }
        allArray.push(...dateArray)
      })
      let beforeStatus = '';
      let newArray = [];
      allArray.map((i, index) => {
        if (beforeStatus == '') {
          beforeStatus = i.status;
        }
        if (
            (i.status !== beforeStatus)
            && beforeStatus != 'new-data'
        ) {
          newArray = newArray.filter(i => i !== beforeStatus);
          newArray.push({
            badge: beforeStatus
          });
          beforeStatus = i.status;
        }
        newArray.push(i);
        if (
            (allArray.length - 1 == index)
            && (i.status !== 'new-data')
        ) {
          newArray.push({
            badge: i.status
          });
        }
      })

      return [...newArray].reverse() ?? null;
    },
    hasValidDeliverySettings() {
      // 1. deliveryOptions이 있는지 확인
      if (!this.showNftDetailsData?.deliveryOptions?.afterDeliveryInfo) {
        return false;
      }

      // 2. afterDeliveryInfo 배열에 유효한 설정이 있는지 확인
      return this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.some(info => 
        info.afterDeliveryDay > 0 && 
        info.afterDeliveryCount > 0 && 
        Array.isArray(info.deliveryDates) && 
        info.deliveryDates.length > 0
      );
    },
    calculatedDeliveryDates() {
      if (!this.deliveryDate || !this.showNftDetailsData?.deliveryOptions?.afterDeliveryInfo?.length) {
        return [];
      }

      return this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((deliveryDay, index) => {
        const dates = [];
        const startDate = this.getDeliveryStartDate(index);

        for (let i = 1; i <= deliveryDay.afterDeliveryCount; i++) {
          const date = startDate.add(deliveryDay.afterDeliveryDay * i, 'day');
          dates.push(date);
        }

        return {
          afterDeliveryDay: deliveryDay.afterDeliveryDay,
          afterDeliveryCount: deliveryDay.afterDeliveryCount,
          dates
        };
      });
    },
    deliveryDatesTableData() {
      if (!this.showNftDetailsData?.deliveryOptions?.afterDeliveryInfo) {
        return [];
      }

      const allDates = [];
      this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.forEach((info, groupIndex) => {
        if (info.deliveryDates) {
          info.deliveryDates.forEach((date) => {
            allDates.push({
              key: `${date.date}-${date.status}`,
              index: groupIndex,  // 규칙 번호를 위한 index
              date: dayjs(date.date).format('YYYY/MM/DD'),
              status: date.status,
              afterDeliveryDay: info.afterDeliveryDay,
              afterDeliveryCount: info.afterDeliveryCount
            });
          });
        }
      });

      // 날짜순으로 정렬
      const sortedDates = allDates.sort((a, b) => dayjs(a.date) - dayjs(b.date));
      
      // 페이지네이션 total 업데이트
      this.deliveryTablePagination.total = sortedDates.length;
      
      return sortedDates;
    },
  },
  watch: {
    showModal(newVal) {
        if (newVal && this.record) {
            // showModal이 true가 되면 record를 showNftDetailsData에 복사
            this.showNftDetailsData = { ...this.record };
        } else {
            // showModal이 false가 되면 showNftDetailsData 초기화
            this.showNftDetailsData = null;
        }
    },
    record(newVal) {
        if (this.showModal && newVal) {
            // record가 변경되고 showModal이 true인 경우 showNftDetailsData 업데이트
            this.showNftDetailsData = { ...newVal };
        }
    },
    showNftDetailsData() {
      if (!this.showNftDetailsData) {
        return false;
      }
      if (this.showNftDetailsData.surgeryAt) {
        this.showNftDetailsData.originalCreateAt = this.showNftDetailsData.surgeryAt;
        this.showNftDetailsData.surgeryAtDayjs = dayjs(this.showNftDetailsData.surgeryAt).format('YYYY-MM-DD');
        this.dateOfSurgeryFromToday = dayjs().startOf('day').diff(dayjs(this.showNftDetailsData.surgeryAt).startOf('day'), 'day')
      }
      if (this.showNftDetailsData.deliveryOptions) {
        if (this.showNftDetailsData.deliveryOptions.surgeryEndAt) {
          this.showNftDetailsData.deliveryOptions.surgeryEndAt = dayjs(this.showNftDetailsData.deliveryOptions.surgeryEndAt);
          this.daysLeftUntilSurgeryEndAtFromToday = this.showNftDetailsData.deliveryOptions.surgeryEndAt.startOf('day').diff(dayjs().startOf('day'), 'day')
        }
        if (this.showNftDetailsData.deliveryOptions.afterDeliveryInfo) {
          let totalDeliveryCount = 0;
          this.showNftDetailsData.deliveryOptions.afterDeliveryInfo = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle, index) => {
            return {
              ...currentSendCycle,
              afterDeliveryDay: parseInt(currentSendCycle.afterDeliveryDay),
              afterDeliveryCount: parseInt(currentSendCycle.afterDeliveryCount),
              originalAfterDeliveryCount: currentSendCycle.originalAfterDeliveryCount ? currentSendCycle.originalAfterDeliveryCount : parseInt(currentSendCycle.afterDeliveryCount)
            }
          })
          this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle, index) => {
            if (currentSendCycle.currentDeliveryCount) {
              totalDeliveryCount = totalDeliveryCount + currentSendCycle.currentDeliveryCount;
            }
          })
          this.totalDeliveryCount = totalDeliveryCount;
        }
        if (this.showNftDetailsData.deliveryOptions.baseAt) {
          this.deliveryDate = dayjs(new Date(this.showNftDetailsData.deliveryOptions.baseAt));
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', false);
    },
    // 품종 가져오기
    convertDateTime,
    acceptNumber() {
      this.customerInfo.mobile = phoneNumberFormatter(this.customerInfo.mobile);
    },
    handleSurgeryEndAt(value) {
      this.showNftDetailsData.deliveryOptions.surgeryEndAt = value;
    },
    handleDeliveryDate(value) {
      this.deliveryDate = value;
    },
    handleBirthday(value) {
      this.customerInfo.birth = value;
    },
    handleGenderChange(gender) {
      this.customerInfo.gender = gender;
    },
    async changeNftDetails(i) {
      this.showNftDetailsIndex = i;
      const query = { ...this.$route.query };
      // currentPage 쿼리 업데이트
      query.nftIndex = i;
      // 라우터 업데이트 (히스토리 남기지 않음)
      await this.$router.replace({ query });
      if (this.nftList[i]?.issueStatus != WarrantyStatusEnum.DISPOSED && this.nftList[i]?.issueStatus != WarrantyStatusEnum.RETURNED) {
        this.showNftDetailsData = this.nftList[i];
        
        // 페이지네이션 초기화
        this.deliveryTablePagination = {
          current: 1,
          pageSize: 10,
          total: 0,
          size: 'small',
          position: ['topRight'],
          showSizeChanger: true,
          showTotal: (total) => `총 ${total}개`,
          pageSizeOptions: ['10', '20', '50'],
          locale: {
            items_per_page: '개씩 보기',
            jump_to: '이동',
            jump_to_confirm: '확인',
            page: '페이지',
            prev_page: '이전 페이지',
            next_page: '다음 페이지',
            prev_5: '5페이지 뒤로',
            next_5: '5페이지 앞으로',
            prev_3: '3페이지 뒤로',
            next_3: '3페이지 앞으로'
          }
        };
      } else {
        this.showNftDetailsData = null;
      }
    },
    getImageUrl(item) {
      if (item?.issueStatus === WarrantyStatusEnum.DISPOSED) {
        return WarrantyImgUrlEnum.DISPOSED;
      }
      if (item?.issueStatus === WarrantyStatusEnum.RETURNED) {
        return WarrantyImgUrlEnum.RETURNED;
      }
      if (item?.products?.image) {
        return item?.products?.image;
      }
      return this.defaultImageUrl;
    },

    validateIsAvailable(message) {
      switch (message) {
        case 'returned':
          return false;
        case 'disposed':
          return false;
        case 'request-issued':
          return true;
        case 'Y':
          return true;
        case 'N':
          return true;
        default:
          return true;
      }
    },
    generateTitleText(issueStatus) {
      switch (issueStatus) {
        case WarrantyStatusEnum.DISPOSED:
          return `삭제된 인증서입니다`;
        case WarrantyStatusEnum.RETURNED:
          return `회수된 인증서입니다`;
        default:
          return '';
      }
    },
    async getMedicalDept() {
      this.medicalDept = this.$store.getters.getMedicalDept;
    },
    async fetchData() {
      this.$store.commit('setIsLoading', true);

      try {
        const obj = {
          "page": this.paginationData.currentPage,
          "limit": this.paginationData.rowsPerPage
        };
        const response = await this.$apiInstance.post(`/customers/v3?customerMobile=${this.$route.query.customerMobile}&customerName=${this.$route.query.customerName}&deliveryChannel=${this.$route.query.activeTab}`, obj);

        if (response && (response.status === 200 || response.status === 201) && response.data) {
          const customerInfo = response.data.customerInfo;
          if (customerInfo) {
            this.customerInfo = {
              ...customerInfo,
              birth: customerInfo.birth ? dayjs(customerInfo.birth) : '',
            };
            this.customerInfo.mobile = customerInfo.deleteYn === YnEnum.Y
                ? customerInfo.mobile
                : phoneNumberFormatter(customerInfo.mobile);

            if (customerInfo.deleteYn !== YnEnum.Y && customerInfo.teethNos) {
              this.dentPrevTeethArray = customerInfo.teethNos;
            }
          }

          if (Array.isArray(response.data.nftList.docs)) {
            this.nftList = response.data.nftList.docs;
            this.paginationData.total = response.data.nftList.totalDocs;
            this.paginationData.totalPages = response.data.nftList.totalPages;
            this.noResult = this.nftList.length === 0;

            let arrayIndex = -1;
            this.nftList = this.nftList.map(i => {
              arrayIndex++;
              return {
                ...i,
                index: arrayIndex
              }
            });
            const newArray = [...this.dentPrevTeethArray];
            this.nftList.forEach((currentNFT, i) => {
              if (currentNFT) {
                currentNFT.issueMessage = currentNFT.issueStatus || currentNFT.issueType;

                const product = currentNFT.products;
                if (product && product.group_name) {
                  currentNFT.products.background_color =
                      currentNFT.issueStatus !== 'returned' && currentNFT.issueStatus !== 'disposed'
                          ? product.background_color
                          : this.defaultColorCode;
                  if (product.group_name === CertifiedCompanies.dentium.name) {
                    currentNFT.products.background_color = CertifiedCompanies.dentium.colorCode;
                  } else if (product.group_name === SurfaceCompanies.plasmapp.name) {
                    currentNFT.products.background_color = SurfaceCompanies.plasmapp.colorCode;
                  } else if (product.group_name === OphCompanies.zeiss.name) {
                    currentNFT.products.background_color = OphCompanies.zeiss.colorCode;
                  }
                }
                const teethNo = getValueByTraitType(currentNFT.products?.attributes, '치아번호');
                if (teethNo) {
                  newArray.push(parseInt(teethNo))
                }

                currentNFT.descText = this.generateDescriptionText(currentNFT);
              }
            });

            if (this.nftList.length > 0) this.changeNftDetails(this.showNftDetailsIndex);
            const setArray = new Set(newArray);
            this.dentPrevTeethArray = Array.from(setArray);
          }
        }
      } catch (error) {
        logging().exceptProd(error);
        this.$store.commit('setIsLoading', false);
      } finally {
        this.$store.commit('setIsLoading', false);
      }
    },
    async sendTheCurrentNftClaraAlimtalk(index, date) {
      try {
        // console.log(index, date)
        // return;
        if (!this.showNftDetailsData) {
          return false;
        }

        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        const isFutureDate = dayjs(date).isAfter(dayjs(), 'day');
        
        let messageContent = `환자에게 투명교정 알림톡을 다시 보내시겠습니까?`;
        
        const status = this.getDeliveryStatus(index, date);
        const isBookStatus = status === 'book';
        
        // 미래 날짜이면서 book 상태인 경우에만 경고 메시지 표시
        if (isFutureDate && isBookStatus) {
          messageContent = `이 알림톡은 ${dayjs(date).format('YYYY년 MM월 DD일')}에 발송 예정된 메시지입니다. 지금 발송하시면 예정된 자동 발송 대상에서 제외됩니다. 그래도 지금 발송하시겠습니까?`;
        }

        const isConfirmed = await twoBtnHtmlDialog(`인증서 알림 다시 보내기`, messageContent);
        if (!isConfirmed) return;
        this.$store.commit('setIsLoading', true);

        const obj = {
          index,
          date: formattedDate,
        }
        const response = await this.$apiInstance.post(`/messages/change/clara-ai/${this.showNftDetailsData._id}`, obj);

        this.$store.commit('setIsLoading', false);
        if (response && (response.status === 200 || response.status === 201) && response.data && response.data.status !== 400) {
          await oneBtnDialog(`투명 교정 교체 알림톡 보내기 완료`, `환자에게 교체 알림톡이 다시 발송되었습니다.`, true);
        } else {
          console.log(response)
          await oneBtnDialog(`투명 교정 교체 알림톡 보내기 실패`, response.data.message, false);
        }
      } catch (error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog(`투명 교정 교체 알림톡 보내기 실패`, `투명 교정 교체 알림톡 재발송에 실패하였습니다.`, false);
      } finally {
        this.$store.commit('setIsLoading', false);
      }
    },
    getDeliveryStatus(index, date) {
      try {
        if (!this.showNftDetailsData?.deliveryOptions?.afterDeliveryInfo) {
          return null;
        }
        
        const afterDeliveryInfo = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo;
        if (!afterDeliveryInfo[index] || !afterDeliveryInfo[index].deliveryDates) {
          return null;
        }
        
        // 해당 날짜와 일치하는 deliveryDate 항목 찾기
        const targetDate = dayjs(date).format('YYYY-MM-DD');
        const deliveryDate = afterDeliveryInfo[index].deliveryDates.find(
          item => dayjs(item.date).format('YYYY-MM-DD') === targetDate
        );
        
        return deliveryDate ? deliveryDate.status : null;
      } catch (error) {
        console.error('상태 확인 중 오류 발생:', error);
        return null;
      }
    },
    generateDescriptionText(nft) {
      // 병원, 시간, 수술부위,
      let surgeryAreaText = '';
      let hospitalText = '';
      let createAtText = '';
      if (nft) {
        surgeryAreaText = this.getSurgeryPartText(nft);

        // 수술 병원은 attributes에서 찾기
        createAtText = convertDate(nft.surgeryAt);
        // products가 있는 경우, 없는 경우 나누어야 함

        hospitalText = getValueByTraitType(nft.products?.attributes, '병원명');
      }

      let result = `${hospitalText}·${createAtText}·${surgeryAreaText}`;
      if (result.includes('undefined')) result.replace('undefined', '');
      return result;
    },
    getOldSurgeryPartText(object) {
      const nftItem = object.products ? object.products : object;
      const teethNum = getValueByTraitType(nftItem?.attributes, '치아번호');
      if (teethNum) {
        return `${teethNum} 번 치아`;
      }

      if (nftItem?.name?.includes('좌안')) {
        return OphSurgeryPart.LEFT;
      }

      if (nftItem?.name?.includes('우안')) {
        return OphSurgeryPart.RIGHT;
      }

      return '';
    },
    getSurgeryPartText(object) {
      if (!object.surgeryArea) {
        return this.getOldSurgeryPartText(object);
      }

      const {productType, dept, value} = object.surgeryArea;

      if (dept === MedicalDept.DENT) {
        if (productType && productType === '투명교정') {
          return value;
        }
        return `${value}번 치아`;
      }

      if (dept === MedicalDept.OPH) {
        return value;
      }

      return value;
    },
    addSendCycle() {
      this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.push(
          {
            afterDeliveryDay: 10,
            afterDeliveryCount: 3,
            isNewData: true
          }
      )
    },
    deleteSendCycle(index) {
      this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.splice(index, 1);
    },
    // 통합된 날짜 계산 함수
    calculateDeliveryDates(info, index) {
      const deliveryDates = [];
      const startDate = this.getDeliveryStartDate(index);

      // 기존 deliveryDates의 상태 정보를 보존
      const existingDates = info.deliveryDates || [];

      // 각 규칙별 발송 예정일 계산
      for (let i = 1; i <= info.afterDeliveryCount; i++) {
        const date = startDate.add(info.afterDeliveryDay * i, 'day');
        const dateStr = date.format('YYYY-MM-DD');
        
        // 기존 날짜의 상태를 찾음
        const existingDate = existingDates.find(d => d.date === dateStr);
        
        deliveryDates.push({
          date: dateStr,
          // 기존 상태가 있으면 유지, 없으면 새로운 상태 부여
          status: existingDate ? existingDate.status : 
                 (info.currentDeliveryCount && i <= info.currentDeliveryCount ? 'sent' : 'book'),
          // SPEC-CLARA-DELIVERY-STATUS-001 (P2): 기존 marker 보존(서버가 경과 날짜를 권위 정합)
          marker: existingDate ? (existingDate.marker || 'none') : 'none',
        });
      }

      return deliveryDates;
    },
    // 발송 주기 수정 함수
    async updateDeliveryOptions() {
      const surgeryEndAt = this.showNftDetailsData.deliveryOptions.surgeryEndAt.format('YYYY-MM-DD');

      if (!surgeryEndAt || (surgeryEndAt && surgeryEndAt.length < 10)) {
        await oneBtnDialog('교정 종료 예상일 오류', '교정 종료 예상일을 올바르게 입력해 주세요.', false);
        return false;
      }

      // DeliveryOptionsDto 형식에 맞게 데이터 구성
      const deliveryOptionsDto = {
        surgeryEndAt: surgeryEndAt,
        afterDeliveryInfo: this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((info, index) => {
          // 발송 날짜 재계산 시 기존 상태 유지
          const deliveryDates = this.calculateDeliveryDates(info, index);
          
          return {
            afterDeliveryDay: info.afterDeliveryDay,
            afterDeliveryCount: info.afterDeliveryCount,
            currentDeliveryCount: info.currentDeliveryCount || 0,
            deliveryDates: deliveryDates,
            alimtalkTemplate: info.alimtalkTemplate || 'BIZMSG_CLARA_CHANGE'
          };
        })
      };

      // 계산된 발송 날짜 데이터를 저장
      this.deliveryRulePreviewData = deliveryOptionsDto.afterDeliveryInfo;

      console.log('규칙데이터 미리보기:', {
        deliveryOptionsDto,
        previewData: this.deliveryRulePreviewData,
        hasValidSettings: this.hasValidDeliverySettings
      });

      const nftId = this.showNftDetailsData._id;
      const baseAt = dayjs(this.deliveryDate).format('YYYY-MM-DD');

      const isConfirmed = await twoBtnDialog(`발송 주기 수정`, `발송 주기를 수정하시겠습니까?`, '저장');
      if (!isConfirmed) return false;  // 취소를 선택한 경우 false 반환

      try {
        const response = await this.$apiInstance.put(
          `/nfts/delivery/options/${nftId}/${baseAt}`,
          deliveryOptionsDto
        );

        if (response.status === 200 || response.status === 201) {
          await oneBtnDialog('발송 주기 수정 완료', '발송 주기 수정이 완료되었습니다.', true);
          return true;  // 성공적으로 저장된 경우 true 반환
        }
      } catch (error) {
        console.error('발송 주기 수정 실패:', error);
        await oneBtnDialog('발송 주기 수정 실패', '발송 주기 수정에 실패했습니다.', false);
        return false;  // 에러 발생 시 false 반환
      }
    },
    
    async resendNft(record) {
      console.log(record)
      let messageContent = `환자에게 인증서 알림톡을 다시 보내시겠습니까?`;
      if (record.issuanceMethod == "CLARA_ALIMTALK_REGULARLY") {
        messageContent = `환자에게 인증서 알림톡을 다시 보내시겠습니까?<br/>* 투명교정 교체 알림은 '인증서 상세설정'에서 보내주세요.`;
      }
      const isConfirmed = await twoBtnHtmlDialog(`인증서 알림 다시 보내기`, messageContent);
      if (!isConfirmed) return;
      try {
        const response = await this.$apiInstance.post(`/nfts/re-send/bulk/${record.subCampaignId}`);
        if ((response.status !== 200 && response.status !== 201)) return;
        await oneBtnDialog(`인증서 알림 보내기 완료`, `환자에게 인증서 알림톡이 다시 발송되었습니다.`, false);
      } catch (error) {
        console.log(error);
        await oneBtnDialog(`인증서 알림 보내기 실패`, `인증서 알림톡 재발송에 실패하였습니다.`, false);
      }
    },
    scrollToItem() {
      this.$nextTick(() => {
        if (this.$refs[`issueList${this.showNftDetailsIndex}`] && 
            this.$refs[`issueList${this.showNftDetailsIndex}`][0]) {
            this.$refs[`issueList${this.showNftDetailsIndex}`][0].scrollIntoView({
                // behavior: 'smooth',
                block: 'center'
            });
        }
      });
    },
    formatDate(date) {
      const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
      const weekday = weekdays[dayjs(date).day()];
      return dayjs(date).format('YYYY년 M월 D일') + ` (${weekday})`;
    },
    getDeliveryStartDate(index) {
      if (!this.deliveryDate || index === 0) {
        return dayjs(this.deliveryDate);
      }

      // 이전 규칙들의 모든 발송일을 누적해서 계산
      let startDate = dayjs(this.deliveryDate);
      for (let i = 0; i < index; i++) {
        const prevItem = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo[i];
        if (prevItem && prevItem.afterDeliveryDay && prevItem.afterDeliveryCount) {
          startDate = startDate.add(prevItem.afterDeliveryDay * prevItem.afterDeliveryCount, 'day');
        }
      }

      return startDate;
    },
    getLastDeliveryDate(item, index) {
      try {
        if (!this.deliveryDate || !item.afterDeliveryDay || !item.afterDeliveryCount) {
          return '-';
        }

        const startDate = this.getDeliveryStartDate(index);
        const lastDeliveryDate = startDate.add(item.afterDeliveryDay * item.afterDeliveryCount, 'day');

        return lastDeliveryDate.format('YYYY/MM/DD');
      } catch (error) {
        console.error('마지막 발송일 계산 중 오류:', error);
        return '-';
      }
    },
    async handleDeleteDelivery(record) {
      const isConfirmed = await twoBtnDialog(
        '발송 예정일 삭제',
        '선택한 발송 예정일을 삭제하시겠습니까?\n삭제 후 자동으로 저장됩니다.',
        '삭제'
      );
      if (!isConfirmed) return;

      try {
        // 해당 그룹의 afterDeliveryCount 감소
        const groupInfo = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo[record.index];
        if (groupInfo && groupInfo.afterDeliveryCount > groupInfo.currentDeliveryCount) {
          groupInfo.afterDeliveryCount--;
          
          // 발송 날짜 재계산
          groupInfo.deliveryDates = this.calculateDeliveryDates(groupInfo, record.index);
          
          // DB 업데이트
          const nftId = this.showNftDetailsData._id;
          const baseAt = dayjs(this.deliveryDate).format('YYYY-MM-DD');
          
          // DeliveryOptionsDto 형식에 맞게 데이터 구성
          const deliveryOptionsDto = {
            surgeryEndAt: this.showNftDetailsData.deliveryOptions.surgeryEndAt.format('YYYY-MM-DD'),
            afterDeliveryInfo: this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((info, index) => ({
              afterDeliveryDay: info.afterDeliveryDay,
              afterDeliveryCount: info.afterDeliveryCount,
              currentDeliveryCount: info.currentDeliveryCount || 0,
              deliveryDates: this.calculateDeliveryDates(info, index),
              alimtalkTemplate: info.alimtalkTemplate || 'BIZMSG_CLARA_CHANGE'
            }))
          };

          try {
            const response = await this.$apiInstance.put(
              `/nfts/delivery/options/${nftId}/${baseAt}`,
              deliveryOptionsDto
            );

            if (response.status === 200 || response.status === 201) {
              await oneBtnDialog('삭제 완료', '발송 예정일이 삭제되었습니다.', false);
            }
          } catch (error) {
            // 저장 실패 시 변경사항 되돌리기
            groupInfo.afterDeliveryCount++;
            groupInfo.deliveryDates = this.calculateDeliveryDates(groupInfo, record.index);
            throw error;
          }
        }
      } catch (error) {
        console.error('삭제 실패:', error);
        await oneBtnDialog('삭제 실패', '발송 예정일 삭제에 실패했습니다.', false);
      }
    },
    handleDeliveryTableChange(pagination) {
      this.deliveryTablePagination = {...pagination};
    },
    formatSurgeryArea(surgeryArea) {
      if (!surgeryArea) return '-';
      
      // 객체인 경우 처리
      if (typeof surgeryArea === 'object') {
        // surgeryArea가 배열인 경우
        if (Array.isArray(surgeryArea)) {
          return surgeryArea.join(', ');
        }
        // surgeryArea가 일반 객체인 경우
        return surgeryArea.name || surgeryArea.value || surgeryArea.text || JSON.stringify(surgeryArea);
      }
      
      // 문자열인 경우 그대로 반환
      return surgeryArea;
    }
  },
};
</script>
<style lang="scss" scoped>
.teeth-and-margin {
  max-height: 100%;
}

.delivery-dates-modal-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 16px;

  .no-dates-message {
    text-align: center;
    color: #999;
    padding: 20px;
  }

  .delivery-group {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .group-header {
      font-weight: bold;
      margin-bottom: 12px;
      color: #1890ff;
    }

    .dates-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 8px;
    }

    .date-item {
      padding: 8px 12px;
      background-color: #f5f5f5;
      border-radius: 4px;
      font-size: 14px;
    }
  }
}

.view-dates-btn {
  &:hover {
    background-color: #f5f5f5;
  }
}

.delivery-dates-list {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .delivery-date-item {
    span {
      color: #333;

      &.sent {
        color: #999;
      }
    }

    .status-badge {
      margin-left: 8px;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;

      &.sent {
        background-color: #f5f5f5;
        color: #999;
      }

      &.book {
        background-color: #e6f7ff;
        color: #1890ff;
      }
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;

  &.sent {
    background-color: #f5f5f5;
    color: #999;
  }

  &.book {
    background-color: #e6f7ff;
    color: #1890ff;
  }
}

// 테이블 스타일 추가
:deep(.ant-table-thead > tr > th) {
  background-color: #fafafa;
  font-weight: 600;
}

:deep(.ant-table-tbody > tr > td) {
  vertical-align: middle;
}

.kakao-icon {
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

// 테이블 내 버튼 정렬을 위한 스타일
:deep(.ant-table-cell) {
  .kakao-icon {
    margin: 0 auto;
  }
}

:deep(.ant-pagination) {
  margin-top: 16px;
  text-align: right;
}

:deep(.ant-pagination-total-text) {
  float: left;
}

:deep(.ant-select-selector) {
    border-radius: 4px !important;
}

.mobile-input-wrap {
  display: flex;
  gap: 4px;
}
</style>